module.exports = __webpack_public_path__ + "media/images/flags/tf-0ab93acc2e9c86ed30126b25ba2273f5.svg";